import { NgModule } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SharedModule } from './shared/shared.module';
import { AuthenticationModule, LoginPageModule } from '@soleran/authentication';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    LoginPageModule.forRoot({
      embedUrl: 'https://login.soleran.net',
      baseUrl: window.location.origin,
    }),

    AuthenticationModule.forRoot({
      loginPath: '/login',
      afterLoginPath: '/dashboard',
      afterLogoutPath: '',
    }),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(reg: MatIconRegistry, private san: DomSanitizer) {
    const { protocol, host } = window.location;
    reg.addSvgIcon(
      'soleran',
      san.bypassSecurityTrustResourceUrl(
        `${protocol}//${host}/assets/icons/soleran.svg`
      )
    );
  }
}
